
const KPIState = {
    state: {
        _compareMode: false,
        _compareType: undefined,
        _treeNodes: [],
        _selectedNodes: [],
        _tableItem: [],
        _notShowWarning: false,
        _manageWarning: false,
        _lastClickedNode: {},
        _maxLimitSelection: 10,
        _matchElements: false,
        _timer: null,
        _timeout: 3000,
        _penColors: [],
    },
    getters: {
        compareMode(state) {
            return state._compareMode;
        },
        compareType(state) {
            return state._compareType;
        },
        treeNodes(state) {
            return state._treeNodes;
        },
        tableItem(state) {
            return state._tableItem;
        },
        notShowWarning(state) {
            return state._notShowWarning;
        },
        manageWarning(state) {
            return state._manageWarning;
        },
        lastClickedNode(state) {
            return state._lastClickedNode
        },
        selectedNodes(state) {
            return state._selectedNodes
        },
        maxLimitSelection(state) {
            return state._maxLimitSelection
        },
        matchElements(state) {
            return state._matchElements
        },
        timer(state) {
            return state._timer
        },
        timeout(state) {
            return state._timeout
        },
        penColors(state) {
            return state._penColors
        }
    },
    //  should only change states
    mutations: {
        setCompareMode(state, data) {
            state._compareMode = data;
        },
        setCompareType(state, data) {
            state._compareType = data;
        },
        setTreeNode(state, node) {
            if (!Array.isArray(node)) {
                node = [node];
            }
            state._treeNodes = node;
        },
        addTreeNode(state, node) {
            state._treeNodes.push(node);
        },
        removeTreeNode(state, node) {
            state._treeNodes = state._treeNodes.filter(n => n !== node);
        },
        setTableItem(state, data) {
            state._tableItem = data;
        },
        clearKPI(state) {
            state._compareMode = false;
            state._compareType = undefined;
            state._tableItem = [];
            state._treeNodes = [];
            state._selectedNodes = [];
        },
        setWarning(state, data) {
            state._notShowWarning = data;
        },
        setManageWarning(state, data) {
            state._manageWarning = data;
        },
        setLastClickedNode(state, data) {
            state._lastClickedNode = data;
        },
        setSelectedNodes(state, data) {
            state._selectedNodes = [...data];
        },
        setMatchElements(state, data) {
            state._matchElements = data;
        },
        setTimer(state, data) {
            clearTimeout(state._timer)

            state._timer = data;
        },
        addPenColors(state, data) {
            state._penColors.push(data);
        },
        clearPenColors(state) {
            state._penColors = []
        }
    },
    // contains the business logic
    actions: {
        /**
         * Change compare mode
         * If compareMode is set to false, action will select the first node
         * on the current selection list
         */
        KPICompareMode({ commit, getters, dispatch }, compareMode) {
            if (!compareMode) {
                commit("setTreeNode", getters.treeNodes[0]);
            }

            commit("setCompareMode", compareMode);
            dispatch("KPIConfirmSelection")

        },
        /**
         * Set or Add or Remove node from selection if compare mode is true
         * By default you cannot have an empty selection after the first selection
         * And verify instance type to define wether or not it will overwrite current selection
         */
        KPISelectTreeNode({ commit, getters, dispatch }, [node, mode]) {
            const { compareMode, treeNodes, compareType, notShowWarning, maxLimitSelection } = getters;

            // Necessary to open warning before the node be added
            if (compareMode && !notShowWarning && compareType !== node.type()) {
                commit("setManageWarning", true);
                commit("setLastClickedNode", node);
                return;
            }
            if (!compareMode || compareType !== node.type()) {
                commit("setTreeNode", node);
                commit("setCompareType", node.type());
                if (!compareMode) dispatch("KPIConfirmSelection")
                return;
            }
            // Check if is same object on memory
            const item = treeNodes.find(n => n === node);

            if (item && treeNodes.length > 1 && mode != 'add') {
                commit("removeTreeNode", node);
            } else if (!item && treeNodes.length < maxLimitSelection && mode != 'remove') {
                commit("addTreeNode", node);
            }
            dispatch("KPIMatchElements")

        },
        KPITableItem({ commit }, item) {
            commit("setTableItem", item);
        },
        // Open/close the warning message
        KPIManageWarning({ commit }, item) {
            commit("setManageWarning", item);
        },
        // Take the value in local storage
        KPISetWarning({ commit }, item) {
            commit("setWarning", item)
        },
        // When the warning is showed and the user clicks in OK
        KPIWarningConfirm({ commit, getters, dispatch }) {
            const { lastClickedNode, manageWarning } = getters;
            commit("setTreeNode", lastClickedNode);
            commit("setCompareType", lastClickedNode.type());
            dispatch("KPIManageWarning", false)
            dispatch("KPIConfirmSelection")

        },
        /*
        Refers to confirm button on tree view, in compare mode it's set when is clicked
        When not in compare mode, it's always set in node changes
        */
        KPIConfirmSelection({ commit, getters, dispatch }) {
            const { treeNodes, compareMode, timeout, manageWarning } = getters
            if (compareMode) {
                if (manageWarning) return;
                commit("setTimer", setTimeout(() => {
                    commit("clearPenColors")
                    commit("setSelectedNodes", treeNodes)

                    dispatch("KPIMatchElements")
                }, timeout + 500)) // 500 ms is a correction delay
            } else {
                commit("setSelectedNodes", treeNodes)
                dispatch("KPIMatchElements")
            }
        },
        KPIMatchElements({ commit, getters }) {
            const { treeNodes, selectedNodes } = getters
            let foundElements = 0;
            selectedNodes.forEach((element) => {
                if (treeNodes.find((el) => element.id === el.id)) {
                    foundElements++;
                }
            });
            let data = foundElements === selectedNodes.length && treeNodes.length === selectedNodes.length
            commit("setMatchElements", data)
        },
        KPIClearStore({ commit }) {
            commit("clearKPI");
        },
        KPIAddPenColors({ commit, getters }, [key, color]) {
            const { penColors } = getters;
            const item = { key, color }
            if (!penColors.find(el => el.key == key)) {
                commit("addPenColors", item)
            }
        },
    }
};


export default KPIState;
